import { useIntl } from "react-intl";
import BreadcrumbItem from "./BreadcrumbItem";
import Breadcrumb from "./Breadcrumb";
import { url } from "../../utils";
import ObjectPathTopology from "../ObjectPathTopology/ObjectPathTopology";
import { objectPathsShape } from "../../shapes/objectPathShape";

const TARGET_PATHS = {
  Node: "/nodes",
  Instrumentation: "/instrumentations",
  Asset: "/assets",
};

const getTarget = (id: $TSFixMe, type: $TSFixMe) =>
  `${
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    TARGET_PATHS[type]
  }/${id}`;

type NavigationBreadCrumbsProps = {
  paths?: objectPathsShape;
};

export function NavigationBreadCrumbs({ paths }: NavigationBreadCrumbsProps) {
  const intl = useIntl();

  const firstPath = paths?.[0]?.items;
  const lastItemOfFirstPath = firstPath?.[firstPath.length - 1];
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const hasMultiplePaths = paths?.length > 1;

  const generateCrumbs = () => {
    const crumbs = [
      {
        id: 0,
        name: intl.formatMessage({ id: "navigation.all_objects" }),
        target: "/nodes",
      },
    ];

    if (hasMultiplePaths) {
      crumbs.push({
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        id: lastItemOfFirstPath.id,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        name: lastItemOfFirstPath.display_name,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        target: getTarget(lastItemOfFirstPath.id, lastItemOfFirstPath.type),
      });
    } else if (paths) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const additionalPaths = firstPath.map((path: $TSFixMe) => ({
        id: path.id,
        name: path.display_name,
        target: getTarget(path.id, path.type),
      }));

      crumbs.push(...additionalPaths);
    }

    return crumbs;
  };

  const crumbs = generateCrumbs();

  return (
    <Breadcrumb id="nodes-header">
      {crumbs.map((item, index) => (
        <BreadcrumbItem
          key={item.id}
          title={item.name}
          className={`breadcrumb-item${crumbs.length - 1 === index ? " last-breadcrumb" : ""}`}
          target={crumbs.length - 1 !== index ? url(item.target) : undefined}
        />
      ))}
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {paths?.length > 0 && (
        <ObjectPathTopology
          key={`OPT-${lastItemOfFirstPath?.id}`}
          // @ts-expect-error TS(2322) FIXME: Type 'objectPathsShape | undefined' is not assigna... Remove this comment to see the full error message
          paths={paths}
        />
      )}
    </Breadcrumb>
  );
}

export default NavigationBreadCrumbs;
